var $ = require('jquery');

"use strict";

var PLUGIN_NAME = "gtmHandler";

var DEFAULTS = {
	debug: false,		// v debug rezimu se data neodesilaji, jen se zobrazuji v konzoli
	ajaxLoad: false		// identifikace, zda je inicializace pluginu standardni nebo na zaklade dokonceneho ajax pozadavku
};


/**
 * funkce vrati pole objektu sesbiranych dat z elementu s data-gtm atributem
 * @returns {[]}
 */
var gtmHandlerGetPageData = function() {
	var pageData = [];
	$('[data-gtm]').each(function(){
		pageData.push($(this).data('gtm'));
	});
	return pageData;
};

/**
 *  funkce vrati preparsovany string htmlData jako JSON objekt
 * @param htmlData
 */
var gtmHandlerGetJsonData = function(htmlData) {
	var result = htmlData;
	return result;
};

/*
	data-gtm data se ulozi do globalni promenne
 */
var gtmHandlerPageData = gtmHandlerGetPageData();
$(document).ajaxStop(function(){
	gtmHandlerPageData = gtmHandlerGetPageData();
});


// plugin constructor
function GtmHandler(element, options) {
	this.element = element;
	this.$me = $(this.element);

	this.options = $.extend(true, {}, DEFAULTS, options);

	this._defaults = DEFAULTS;
	this._name = PLUGIN_NAME;

	this.bindData = {};

	this.ajaxBinded = [];

	this.initialise();

}

/**
 * inicializace
 */
GtmHandler.prototype.initialise = function() {
	var self = this;

	self.bindData = self.$me.data('gtm-bind');
	self.bindEvents();
};

/**
 * nabindovani udalosti dle dat objektu z elementu s atributem data-gtm-bind
 */
GtmHandler.prototype.bindEvents = function() {
	var self = this,
		object;

	for (var property in self.bindData) {
		if (self.bindData.hasOwnProperty(property)) {
			object = self.bindData[property];

			self.bindEvent(object.on, object.childTarget, object.customMethod, object.data);
		}
	}
};

/**
 * Nabindovani konkretni udalosti na dany objekt
 * @param event: udalost
 * @param childTarget: cilovy element, na ktery se binduje udalost, pokud neni definovano, binduje se na vychozi element
 * @param customMethod: uzivatelska metoda, ktera se v ramci udalosti zpracuje
 * @param data: vlastni data, ziskana z vychoziho elementu
 */
GtmHandler.prototype.bindEvent = function(event, childTarget, customMethod, data) {
	var self = this,
		$target = self.$me;

	if (((event.indexOf('pageLoad') != -1) && (!self.options.ajaxLoad)) || (event.indexOf('ajaxLoad') != -1)) {

		if ((event.indexOf('pageLoad') != -1) && (!self.options.ajaxLoad)) {
			self.processData(customMethod, data, {}, null);
		}
		else {
			$(document).ajaxStop(function(){
				if (self.ajaxBinded.indexOf(data) == -1) {
					self.ajaxBinded.push(data);
					self.processData(customMethod, data, {}, null);
				}
			});
		}
	}
	else {
		if (typeof(childTarget) != 'undefined') {
			$target = self.$me.find(childTarget);
		}

		$target.on(event, function(e, additionalData){
			self.processData(customMethod, data, additionalData, $(this));
		});
	}
};

/**
 * Zpracovani dat behem udalosti
 * @param customMethod: uzivatelska metoda, ktera se v ramci udalosti zpracuje
 * @param data: vlastni data, ziskana z vychoziho elementu
 * @param additionalData: doplnkova data, ktera napriklad primo dana udalost, nebo si je predame parametrem
 * @param $sourceElement: jquery objekt elementu, na kterem doslo k udalosti
 */
GtmHandler.prototype.processData = function(customMethod, data, additionalData, $sourceElement) {
	var self = this,
		resultData;

	resultData = self.handlePageData(data);
	resultData = self.handleCustomMethods(customMethod, resultData, additionalData, $sourceElement);
	self.sendDataToGTM(resultData);
};

/**
 * Zpracovani dat ziskanych ze stranky, v pripade, ze vychozi hodnota klice zacina znakem @, prohleda se objekt dat stranky a nahradi se prislusnou realnou hodnotou
 * @param data: vstupni data objektu
 * @returns {{}}: zpracovana data objektu
 */
GtmHandler.prototype.handlePageData = function(data) {
	var self = this,
		result = {};

	if ($.isArray(data)) {
		result = [];
	}

	if (typeof(data) == 'string') {
		if (data.indexOf('@') == 0) {
			result = self.getPageDataByKey(data);
		}
		else {
			result = data;
		}
	}
	else {
		$.each(data, function (key, value) {
			if (typeof(value) === 'object') {

				if (value === null) {
					result[key] = '';
				}
				else {
					result[key] = self.handlePageData(value);
				}
			}
			else {
				if (value.toString().indexOf('@') == 0) {
					value = self.getPageDataByKey(value);
				}
				result[key] = value;
			}
		});
	}

	return result;
};

/**
 * V pripade ze existuje uzivatelska metoda customMethod, dojde k jejimu provedeni, ktere nejakym zpusobem modifikuje stavajici data objektu
 * @param customMethod: uzivatelska metoda, ktera se v ramci udalosti zpracuje
 * @param data: vychozi data objektu
 * @param additionalData: doplnkova data
 * @param $sourceElement: jquery objekt elementu, na kterem doslo k udalosti
 * @returns {*}: zpracovana data upravena pomoci uzivatelske metody
 */
GtmHandler.prototype.handleCustomMethods = function(customMethod, data, additionalData, $sourceElement) {
	var self = this,
			resultData = data,
			baseCustomMethod;

	if (typeof(customMethod) != 'undefined') {
		baseCustomMethod = customMethod.split('(')[0];
	}

	switch(baseCustomMethod)  {
		case 'setProductQuantityFromEvent':
			resultData = self.customSetProductQuantity(data, additionalData.diff,$sourceElement);
			break;
		case 'setShippingPaymentEEC':
			resultData = self.customSetShippingPaymentEEC(data);
			break;
		case 'setShippingPaymentUX':
			resultData = self.customSetShippingPaymentUX(data, $sourceElement);
			break;
		case 'setInputLabelUX':
			resultData = self.customSetInputLabelUX(data, $sourceElement);
			break;
		case 'setImpressions':
			resultData = self.customSetImpressions(data, additionalData.items);
			break;
		case 'setProductClickFromItemEEC':
			resultData = self.customSetProductClickFromItemEEC(data, $sourceElement);
			break;
		case 'setProductClickFromItemUX':
			resultData = self.customSetProductClickFromItemUX(data, $sourceElement);
			break;
		case 'setProductClickFromSelfEEC':
			resultData = self.customSetProductClickFromSelfEEC(data, $sourceElement);
			break;
		case 'setProductClickFromSelfUX':
			resultData = self.customSetProductClickFromSelfUX(data, $sourceElement);
			break;
		case 'setProductFromParentItemEEC':
			resultData = self.customSetProductFromParentItemEEC(data, $sourceElement);
			break;
		case 'setProductFromParentItemUX':
			resultData = self.customSetProductFromParentItemUX(data, $sourceElement);
			break;
		case 'setUrl':
			resultData = self.customSetUrl(data);
			break;
	}

	return resultData;
};

/**
 * Pomocna metoda - ziska ze stringu methodName ve tvaru nazevMetody(x) parametr x
 * @param methodName
 * @returns {*}
 */
GtmHandler.prototype.getParamValue = function(methodName) {
	var self = this,
			result = null,
			bracket1 = methodName.indexOf('('),
			bracket2 = methodName.indexOf(')');

	if ((bracket1 != -1) && (bracket2 != -1)) {
		result = methodName.substr(bracket1+1, (bracket2 - bracket1 - 1));

		if (!isNaN(parseInt(result))) {
			result = parseInt(result);
		}
	}

	return result;
};

/**
 * Nahradi klic key za realna data nalezena v globalni promenne gtmHandlerPageData
 * @param key: string, ktery zacina znakem @
 * @returns {string}
 */
GtmHandler.prototype.getPageDataByKey = function(key) {
	var self = this,
		result = '',
		realKey = key.substring(1);

	if (key.indexOf('*') != -1) {
		realKey = realKey.substring(0,realKey.indexOf('*'));
		result = self.getPageDataByKeyPattern(realKey);
	}
	else {
		result = gtmHandlerPageData[realKey];
		result =  self.handlePageData(result);
	}

	if (typeof(result) == 'undefined') {
		result = '';
	}

	return result;
};

/**
 * Nahradi keyPattern za pole objektu nalezenych v globalni promenne gtmHandlerPageData (nalezne vsechny objekty, ktere zacinaji klicem keyPattern)
 * @param keyPattern
 * @returns {Array}
 */
GtmHandler.prototype.getPageDataByKeyPattern = function(keyPattern) {
	var self = this,
		result = [],
		item,
		value;

	for (var key in gtmHandlerPageData) {
		item = gtmHandlerPageData[key];
		value = item[keyPattern];
		if (typeof(value) != 'undefined') {
			result.push(value);
		}
	}

	return result;
};

/**
 * Odesle data do GTM nebo je zobrazi v konzoli
 * @param data
 */
GtmHandler.prototype.sendDataToGTM = function(data) {
	var self = this,
			dataLayer = window.dataLayer || [];

	if (typeof(data) != 'undefined') {
		if (self.options.debug) {
			console.log('Debug rezim - data, ktera by se odeslala do GTM:');
			console.log(data);
		}
		// push dataLayer
		else {
			dataLayer.push(data);
		}
	}
};


/**
 * Uzivatelska metoda: doplneni produktu z rodice a mnozstvi produktu do dat
 * @param data: vychozi data objektu
 * @param diff: rozdil mnozstvi, oproti predchozimu stavu
 * @param $sourceElement: jquery objekt elementu, na kterem doslo k udalosti*
 * @returns {*}
 */
GtmHandler.prototype.customSetProductQuantity = function(data, diff, $sourceElement) {
	var self = this,
		parentsData = $sourceElement.parents('.product-list__item').children('.cell-product-title').data('gtm'),
		result = [];

	if ((parentsData) && ((data.ecommerce.add) || (data.ecommerce.remove))) {
		for (var prop in parentsData) {
			if (prop.indexOf('fgeEEC') == 0) {
				result.push(parentsData[prop]);
			}
		}

		if (data.ecommerce.add) {
			data.ecommerce.add = {};
			data.ecommerce.add.products = result;
		}
		else {
			data.ecommerce.remove = {};
			data.ecommerce.remove.products = result;
		}
	}

	if (diff > 0) {
		if (data.ecommerce.add) {
			data.ecommerce.add.products[0].quantity = diff;
		}
		else {
			data.ecommerce.remove.products[0].quantity = diff;
		}
	}
	return data;
};


/**
 * Uzivatelska metoda: doplneni zvolene dopravy a platby do dat (jako string oddeleny |)
 * @param data: vychozi data objektu
 * @returns {*}
 */
GtmHandler.prototype.customSetShippingPaymentEEC = function(data) {
	var self = this,
		result = [],
		selectedShipping = $('input[name="frm.shippingCode"]').filter(':checked').next('label').find('.label').text(),
		selectedPayment = $('input[name="frm.paymentCode"]').filter(':checked').next('label').find('.label').text();

	if (selectedShipping != '') {
		result.push(selectedShipping);
	}
	if (selectedPayment != '') {
		result.push(selectedPayment);
	}

	if (result.length > 0) {
		if (data.ecommerce.checkout.actionField.option) {
			data.ecommerce.checkout.actionField.option = result.join(' | ');
		}
	}

	return data;
};

/**
 * Uzivatelska metoda: doplneni zvolene dopravy nebo platby do dat
 * @param data: vychozi data objektu
 * @param $sourceElement: jquery objekt elementu, na kterem doslo k udalosti
 * @returns {*}
 */
GtmHandler.prototype.customSetShippingPaymentUX = function(data, $sourceElement) {
	var self = this,
			label = $sourceElement.next('label').find('.label').text();

	if (data) {
		data.fvLabel = label;
	}

	return data;
};

/**
 * Uzivatelska metoda: doplneni labelu prislusneho elementu, na kterem doslo k udalosti, do dat
 * @param data: vychozi data objektu
 * @param $sourceElement: jquery objekt elementu, na kterem doslo k udalosti
 * @returns {*}
 */
GtmHandler.prototype.customSetInputLabelUX = function(data, $sourceElement) {
	var self = this,
			$label = $('label[for="' + $sourceElement.attr('id') + '"]'),
			label;

	if ($label.length == 1) {
		label = $.trim($label.text());
	}

	if (data) {
		data.fvLabel = label;
	}

	return data;
};


/**
 * Uzivatelska metoda: doplneni dat elementu, ktere jsou viditelne ve viewportu do dat
 * @param data: vychozi data objektu
 * @param items: jquery objekt viditelnych polozek ve viewportu
 * @returns {*}
 */
GtmHandler.prototype.customSetImpressions = function(data, items) {
	var self = this,
		itemData,
		result = [];

	if (items.length > 0) {
		for (var i in items) {
			if (typeof(items[i].data('gtm')) != 'undefined') {
				itemData = items[i].data('gtm');
			}
			else {
				itemData = items[i].find('.cell-product-title, h3 a').data('gtm');
			}

			if (itemData) {
				for (var prop in itemData) {
					if (prop.indexOf('fgeEEC') == 0) {
						result.push(itemData[prop]);
					}
				}
			}
		}
	}

	if (data.ecommerce) {
		data.ecommerce.impressions = result;
	}

	return data;
};


/**
 * Uzivatelska metoda: doplneni dat produktu dlazdice do dat objektu (EEC)
 * @param data: vychozi data objektu
 * @param $sourceElement: jquery objekt elementu, na kterem doslo k udalosti
 * @returns {*}
 */
GtmHandler.prototype.customSetProductClickFromItemEEC = function(data, $sourceElement) {
	var self = this,
			tileData = $sourceElement.parents('.product-list__item, .product-list__tile').data('gtm'),
			result = [];

	if ((tileData) && (data.ecommerce)) {
		for (var prop in tileData) {
			if (prop.indexOf('fgeEEC') == 0) {
				result.push(tileData[prop]);
			}
		}

		data.ecommerce.click = {};
		data.ecommerce.click.products = result;
	}

	return data;
};

GtmHandler.prototype.customSetProductClickFromSelfEEC = function(data, $sourceElement) {
	var self = this,
		tileData = $sourceElement.data('gtm'),
		result = [];

	if ((tileData) && (data.ecommerce)) {
		for (var prop in tileData) {
			if (prop.indexOf('fgeEEC') == 0) {
				result.push(tileData[prop]);
			}
		}

		data.ecommerce.click = {};
		data.ecommerce.click.products = result;
	}

	return data;
};

/**
 * Uzivatelska metoda: doplneni dat produktu dlazdice do dat objektu (UX)
 * @param data: vychozi data objektu
 * @param $sourceElement: jquery objekt elementu, na kterem doslo k udalosti
 * @returns {*}
 */
GtmHandler.prototype.customSetProductClickFromItemUX = function(data, $sourceElement) {
	var self = this,
		tileData = $sourceElement.parents('.product-list__item, .product-list__tile').data('gtm'),
		result = '';

	if ((tileData) && (data)) {
		for (var prop in tileData) {
			if (prop.indexOf('fgeShopUX') == 0) {
				result = tileData[prop];
			}
		}

		data.fvLabel = result;
	}

	return data;
};

GtmHandler.prototype.customSetProductClickFromSelfUX = function(data, $sourceElement) {
	var self = this,
		tileData = $sourceElement.data('gtm'),
		result = '';

	if ((tileData) && (data)) {
		for (var prop in tileData) {
			if (prop.indexOf('fgeShopUX') == 0) {
				result = tileData[prop];
			}
		}

		data.fvLabel = result;
	}

	return data;
};


/**
 * Uzivatelska metoda: doplneni dat produktu polozky do dat objektu (EEC)
 * @param data: vychozi data objektu
 * @param $sourceElement: jquery objekt elementu, na kterem doslo k udalosti
 * @returns {*}
 */
GtmHandler.prototype.customSetProductFromParentItemEEC = function(data, $sourceElement) {
	var self = this,
		parentData = $sourceElement.parents('.product-list__item').children('.cell-product-title').data('gtm'),
		result = [];

	if ((parentData) && (data.ecommerce.remove)) {
		for (var prop in parentData) {
			if (prop.indexOf('fgeEEC') == 0) {
				result.push(parentData[prop]);
			}
		}

		data.ecommerce.remove = {};
		data.ecommerce.remove.products = result;
	}

	return data;
};

/**
 * Uzivatelska metoda: doplneni dat produktu polozky do dat objektu (UX)
 * @param data: vychozi data objektu
 * @param $sourceElement: jquery objekt elementu, na kterem doslo k udalosti
 * @returns {*}
 */
GtmHandler.prototype.customSetProductFromParentItemUX = function(data, $sourceElement) {
	var self = this,
		parentData = $sourceElement.parents('.product-list__item').data('gtm'),
		result = '';

	if ((parentData) && (data)) {
		for (var prop in parentData) {
			if (prop.indexOf('fgeCartUX') == 0) {
				result = parentData[prop];
			}
		}

		data.fvLabel = result;
	}

	return data;
};

/**
 * Uzivatelska metoda: doplni aktualni url do dat
 * @param data: vychozi data objektu
 * @returns {*}
 */
GtmHandler.prototype.customSetUrl = function(data) {
	var url = encodeURI(window.location.href);

	if (data) {
		data.fgAct = url;
	}

	return data;
};


/**
 * decide, which methods will be "public"
 */
var API = {
	//collectPageData: GtmHandler.prototype.collectPageData()
};


/**
 * plugin go live
 * @param value - first param - decides, which action shall be executed
 *         if object - apply plugin with these settings to an selector's elements, if they are clean (plugin not applied yet)
 *         if string && in API object - run method named as this value with all args[index > 0]
 * @return {*}
 */
$.fn[PLUGIN_NAME] = function(value) {
	var args = arguments;


	return this.each(function() {
		var $this = $(this);

		// get plugin instance
		var plugin = $this.data('plugin_' + PLUGIN_NAME);

		// if there's not, create one
		if (!plugin) {
			plugin = new GtmHandler(this, value);
			$this.data('plugin_' + PLUGIN_NAME, plugin);
		}
		// if there is and first parameter is in predefined API methods, call it with rest of params
		else if (API[value]) {
			plugin[value].apply(plugin, Array.prototype.slice.call(args, 1));
		}
	});
};



// WEBPACK FOOTER //
// ./node_modules/fg-frontend/plugins/jquery.gtmHandler.js